exports=module.exports=function(r,o){if(r&&o)for(var e in o)r[e]=o[e];return r};